var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"py-3"},[_c('ProductImages',{attrs:{"product":_vm.product}}),(_vm.product.id)?_c('ProductDetails',{attrs:{"product":_vm.product}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }